import Constants from 'expo-constants';
import {
  Environment,
  getConfig,
  resolveAgentPlatformUrl,
} from './environment-config';
import { Platform } from 'react-native';
import { SupplierDetails } from '../../partners/config/types';

const isNativeApp = Platform.OS !== 'web';

export const expoConfigEnvironment: Environment = isNativeApp
  ? Constants.expoConfig!.extra?.environment
  : window.__PEPPER__.environment;

const resolveRuntimeEnvironment = (): Environment => {
  if (__DEV__) {
    return 'development';
  }
  if (!isNativeApp) {
    return (process.env.NEXT_ENV as Environment | undefined) ?? 'production';
  }
  return 'production';
};

export const runtimeEnvironment: Environment = resolveRuntimeEnvironment();

const resolvedEnvironment =
  expoConfigEnvironment ?? (isNativeApp ? 'production' : undefined);
const config = getConfig(resolvedEnvironment);
const salsaApiUrlOverride =
  process.env.SALSA_API_URL?.trim() ||
  (isNativeApp
    ? (Constants.expoConfig!.extra?.salsaApiUrl as string | undefined)?.trim()
    : undefined);
const salsaApiUrl = salsaApiUrlOverride || config.salsa.apiUrl;

/** The agent platform behind the sales-portal assistant; empty means this environment has none. */
export const agentPlatformUrl = resolveAgentPlatformUrl(
  config.agentPlatform,
  process.env.AGENT_PLATFORM_URL ||
    (isNativeApp
      ? (Constants.expoConfig!.extra?.agentPlatformUrl as string | undefined)
      : undefined),
);

export const amplifyConfig = config.amplify;
export const calyxConfig = config.calyx;
export const salsaConfig = {
  ...config.salsa,
  apiUrl: salsaApiUrl,
  /** Base URL of the Salsa web server (no /api suffix), used for standalone SPA routes */
  webUrl: salsaApiUrl.replace(/\/api$/, ''),
};
export const shishitoConfig = config.shishito;

export const partnerSupplier: SupplierDetails = isNativeApp
  ? Constants.expoConfig!.extra?.supplier
  : window.__PEPPER__.supplier;

export const isActivePartnerApp: boolean = isNativeApp
  ? Constants.expoConfig!.extra?.active === true
  : true;

const fallbackAppURLDomain =
  // Always use usepepper.com in development, otherwise use pepr.app on native or production web
  (isNativeApp || process.env.NEXT_ENV === 'production') && !__DEV__
    ? 'pepr.app'
    : 'usepepper.com';
// On web, take the domain from the request to support per-distributor staging URLs
const appURLDomain = isNativeApp
  ? fallbackAppURLDomain
  : window.__PEPPER__.primaryDomain || fallbackAppURLDomain;
export const partnerSupplierAppURL = `https://${partnerSupplier.subdomain}.${appURLDomain}`;
